import $axiosProtected from "../../../common/utils/axiosUtils";

// Get List of all Indents
export const searchGRN = async (payload: any) => {
    return await $axiosProtected().post(`/inventory/grn/search`, payload);
};
